import React from 'react'
import Footer from '../components/Footer'
import Navigation from '../components/Navigation'
import SearchPage from '../components/SearchPage'

function Search() {
  return (
    <div>
        <Navigation />
        <SearchPage />
        <Footer />
    </div>
  )
}

export default Search
